import React from 'react'

function ClientSingleItem({ClientImg}) {
    return (
        <div className="clientSingleItem">
            <div className="clientSayContent">
                <div className="clientSayInner">
                    <div className="clientSayDetails">
                        <p className="comma">“</p>
                        <p className="clientSay">I loved that I could revisit video lectures anytime. It was like having my professors in my pocket!</p>
                    </div>
                </div>
            </div>
            <div className="clientDetailWrap">
                <div className="clientDetailsInner">
                    <div className="clientImg">
                        <img src={ClientImg} alt="ClientImg" />
                    </div>
                    <div className="clientDetails">
                        <h5 className="clientName">Mufti Abdul Manik</h5>
                        <p className="cleintFrom">Imam, Baitul Aman Jame Masjid</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClientSingleItem
